/**
 * Transições permitidas entre etapas do fluxo de contratação.
 * Padrão: próxima (aprovar), anterior (devolver se permitido), 1ª etapa / terminais (rejeitar).
 * Pular etapas: somente admin.
 */

const TERMINAL_STATUS = new Set(['CONCLUIDO', 'CANCELADO', 'REJEITADO']);

export function ordenarEtapas(etapas = []) {
  return [...(etapas || [])].sort((a, b) => Number(a.ordem || 0) - Number(b.ordem || 0));
}

function permiteDevolverEtapa(etapa) {
  if (!etapa) return true;
  if (etapa.permiteDevolver === false || etapa.permite_devolver === 0) return false;
  return true;
}

/**
 * @returns {{
 *   ordenadas: any[],
 *   idxAtual: number,
 *   permitidas: any[],
 *   idsPermitidos: Set<number>,
 *   proxima: any|null,
 *   anterior: any|null,
 *   inicio: any|null
 * }}
 */
export function calcularTransicoesPermitidas({ etapas, etapaAtualId, etapaAtual }) {
  const ordenadas = ordenarEtapas(etapas);
  const idxAtual = ordenadas.findIndex((e) => Number(e.id) === Number(etapaAtualId));
  const idsPermitidos = new Set();
  const permitidas = [];

  const add = (etapa, motivo) => {
    if (!etapa?.id) return;
    const id = Number(etapa.id);
    if (idsPermitidos.has(id)) return;
    idsPermitidos.add(id);
    permitidas.push({ ...etapa, _transicao: motivo });
  };

  const proxima = idxAtual >= 0 && idxAtual < ordenadas.length - 1 ? ordenadas[idxAtual + 1] : null;
  const anterior = idxAtual > 0 ? ordenadas[idxAtual - 1] : null;
  const inicio = ordenadas[0] || null;

  if (proxima) add(proxima, 'proxima');
  if (anterior && permiteDevolverEtapa(etapaAtual || ordenadas[idxAtual])) {
    add(anterior, 'anterior');
  }
  if (inicio) add(inicio, 'inicio');

  ordenadas.forEach((e) => {
    const st = String(e.status_resultante || e.status || '').toUpperCase();
    if (TERMINAL_STATUS.has(st)) add(e, 'terminal');
  });

  return {
    ordenadas,
    idxAtual,
    permitidas,
    idsPermitidos,
    proxima,
    anterior,
    inicio,
  };
}

export function isTransicaoPadrao(etapaDestinoId, idsPermitidos) {
  if (!idsPermitidos || !etapaDestinoId) return false;
  return idsPermitidos.has(Number(etapaDestinoId));
}

export function destinoPadraoParaAcao(acao, transicoes) {
  if (!transicoes) return '';
  if (acao === 'DEVOLVER') return transicoes.anterior?.id || transicoes.inicio?.id || '';
  if (acao === 'REJEITAR') return transicoes.inicio?.id || '';
  return transicoes.proxima?.id || transicoes.ordenadas[transicoes.ordenadas.length - 1]?.id || '';
}
